<template>
  <v-container fluid class="payrollrecurring-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/payrollrecurring/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-3" @click="findRecurringDialog=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="payrollrecurrings-table"
              show-select
              single-select
              item-key="_id"
              sort-by="payrollrecurringnum"
              :footer-props="footer"
              :headers="itemHeaders"
              :items="payrollrecurrings"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Payroll Recurring?
                    </v-card-title>

                    <v-card-text>
                      {{ deletePayrollRecurring.employeename + ' - ' + deletePayrollRecurring.accountname  }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletePayrollRecurring)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.employeeid="{ item }">
                {{ employees.find(employee=>employee._id == item.employeeid)!==undefined ? employees.find(employee=>employee._id == item.employeeid)['employeecode'] : ''}}
              </template>
              <template v-slot:item.accountid="{ item }">
                {{accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : ''}}
              </template>
              <template v-slot:item.value="{ item }">
                <p class="two-line">{{ item.value }}</p>
                <p class="two-line">{{ item.recurringfrequency }}</p>
              </template>
              <template v-slot:item.payrollrecurringstatus="{ item }">
                <v-chip
                  :color="!item.payrollrecurringstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.payrollrecurringstatus }}
                </v-chip>
              </template>
              <template v-slot:item.paystartdate="{ item }">
                {{ new Date(item.paystartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.payenddate="{ item }">
                {{ new Date(item.payenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div>
    <v-dialog
      v-model="findRecurringDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Recurring</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="employees.filter(x=>x.employeestatus=='Active').map(x => {
                            return {text: x.employeename, value: x._id};
                          })"
                  v-model="query.employeeid"
                  label="Employee"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="findRecurringDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetRecurrings"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findRecurrings"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'payrollrecurringList',
  data() {
    return {
      dialog: false,
      findRecurringDialog: false,
      menu_startdate: null,
      menu_enddate: null,
      deletePayrollRecurring: {},
      itemHeaders: [
        { text: 'Employee', value: 'employeeid' },
        { text: 'Account', value: 'accountid' },
        { text: 'Start', value: 'paystartdate' },
        { text: 'End', value: 'payenddate' },
        { text: 'Value', value: 'value' },
        { text: 'Type', value: 'valuetype' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      list: [],
      query: {},
    }
  },

  computed: {
    ...mapState('PayrollRecurring', ['payrollrecurrings', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating', 'currentEmployeeId']),
    ...mapState('Employee', ['employees']),
    ...mapState('Account', ['accounts']),
  },
  async created() {
    await this.getPayrollRecurringsRequest();
    if(this.employees.length==0){this.getEmployeesRequest()}
    if(this.accounts.length==0){this.getAccountsRequest()}
    this.list = this.payrollrecurrings.filter(payroll=>payroll.employeeid==this.currentEmployeeId);
  },
  methods: {
    ...mapActions('PayrollRecurring', ["setQuery", "getPayrollRecurringsRequest", "getPayrollRecurringsByQueryRequest","deletePayrollRecurringRequest","setCurrentEmployeeId","createPayrollRecurringRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions('Account', ["getAccountsRequest"]),
    editItem(item) {
      this.$router.push({ name: 'PayrollRecurringEdit', params: item })
    },
    deleteItem(item) {
      this.deletePayrollRecurringRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      console.log(this.employees.find(employee=>employee._id == item.employeeid)['employeename']);
      this.deletePayrollRecurring = {
        _id: item._id,
        employeename: this.employees.find(employee=>employee._id == item.employeeid)['employeename'],
        accountname: this.accounts.find(account=>account._id == item.accountid)['accountname'],
      }
    },
    async resetRecurrings(){
      this.query = {};
    },
    async findRecurrings(){
      this.findRecurringDialog = false;
      let payload = Object.assign({}, this.query);
      this.setQuery(payload);
      if(this.query=={}) await this.getRecurringsRequest();
      else await this.getPayrollRecurringsByQueryRequest(this.query);
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
